/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { SubjectDTO } from './SubjectDTO';
import {
    SubjectDTOFromJSON,
    SubjectDTOFromJSONTyped,
    SubjectDTOToJSON,
    SubjectDTOToJSONTyped,
} from './SubjectDTO';
import type { UrlDTO } from './UrlDTO';
import {
    UrlDTOFromJSON,
    UrlDTOFromJSONTyped,
    UrlDTOToJSON,
    UrlDTOToJSONTyped,
} from './UrlDTO';
import type { AdminDataProjectDTO } from './AdminDataProjectDTO';
import {
    AdminDataProjectDTOFromJSON,
    AdminDataProjectDTOFromJSONTyped,
    AdminDataProjectDTOToJSON,
    AdminDataProjectDTOToJSONTyped,
} from './AdminDataProjectDTO';
import type { ProjectOtherPartnerDTO } from './ProjectOtherPartnerDTO';
import {
    ProjectOtherPartnerDTOFromJSON,
    ProjectOtherPartnerDTOFromJSONTyped,
    ProjectOtherPartnerDTOToJSON,
    ProjectOtherPartnerDTOToJSONTyped,
} from './ProjectOtherPartnerDTO';
import type { ProjectToPersonDTO } from './ProjectToPersonDTO';
import {
    ProjectToPersonDTOFromJSON,
    ProjectToPersonDTOFromJSONTyped,
    ProjectToPersonDTOToJSON,
    ProjectToPersonDTOToJSONTyped,
} from './ProjectToPersonDTO';
import type { ReferencedOrganisationDTO } from './ReferencedOrganisationDTO';
import {
    ReferencedOrganisationDTOFromJSON,
    ReferencedOrganisationDTOFromJSONTyped,
    ReferencedOrganisationDTOToJSON,
    ReferencedOrganisationDTOToJSONTyped,
} from './ReferencedOrganisationDTO';
import type { ProjectOtherNameDTO } from './ProjectOtherNameDTO';
import {
    ProjectOtherNameDTOFromJSON,
    ProjectOtherNameDTOFromJSONTyped,
    ProjectOtherNameDTOToJSON,
    ProjectOtherNameDTOToJSONTyped,
} from './ProjectOtherNameDTO';
import type { ReferencedProjectDTO } from './ReferencedProjectDTO';
import {
    ReferencedProjectDTOFromJSON,
    ReferencedProjectDTOFromJSONTyped,
    ReferencedProjectDTOToJSON,
    ReferencedProjectDTOToJSONTyped,
} from './ReferencedProjectDTO';
import type { ProjectInstitutionalIdDTO } from './ProjectInstitutionalIdDTO';
import {
    ProjectInstitutionalIdDTOFromJSON,
    ProjectInstitutionalIdDTOFromJSONTyped,
    ProjectInstitutionalIdDTOToJSON,
    ProjectInstitutionalIdDTOToJSONTyped,
} from './ProjectInstitutionalIdDTO';
import type { ProjectFundingReferenceDTO } from './ProjectFundingReferenceDTO';
import {
    ProjectFundingReferenceDTOFromJSON,
    ProjectFundingReferenceDTOFromJSONTyped,
    ProjectFundingReferenceDTOToJSON,
    ProjectFundingReferenceDTOToJSONTyped,
} from './ProjectFundingReferenceDTO';
import type { ProjectPersonOtherDTO } from './ProjectPersonOtherDTO';
import {
    ProjectPersonOtherDTOFromJSON,
    ProjectPersonOtherDTOFromJSONTyped,
    ProjectPersonOtherDTOToJSON,
    ProjectPersonOtherDTOToJSONTyped,
} from './ProjectPersonOtherDTO';
import type { ExternalIdDTO } from './ExternalIdDTO';
import {
    ExternalIdDTOFromJSON,
    ExternalIdDTOFromJSONTyped,
    ExternalIdDTOToJSON,
    ExternalIdDTOToJSONTyped,
} from './ExternalIdDTO';

/**
 * 
 * @export
 * @interface ProjectDTO
 */
export interface ProjectDTO  {
    /**
     * 
     * @type {number}
     * @memberof ProjectDTO
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDTO
     */
    canEdit?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ProjectDTO
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ProjectDTO
     */
    name?: string;
    /**
     * 
     * @type {Array<ProjectOtherNameDTO>}
     * @memberof ProjectDTO
     */
    otherNames?: Array<ProjectOtherNameDTO>;
    /**
     * 
     * @type {string}
     * @memberof ProjectDTO
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDTO
     */
    oldId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProjectDTO
     */
    startDate?: Date;
    /**
     * 
     * @type {Array<ReferencedProjectDTO>}
     * @memberof ProjectDTO
     */
    parents?: Array<ReferencedProjectDTO>;
    /**
     * 
     * @type {Array<ReferencedProjectDTO>}
     * @memberof ProjectDTO
     */
    childs?: Array<ReferencedProjectDTO>;
    /**
     * 
     * @type {Array<ReferencedProjectDTO>}
     * @memberof ProjectDTO
     */
    successor?: Array<ReferencedProjectDTO>;
    /**
     * 
     * @type {Array<ReferencedProjectDTO>}
     * @memberof ProjectDTO
     */
    predecessors?: Array<ReferencedProjectDTO>;
    /**
     * 
     * @type {Array<ReferencedOrganisationDTO>}
     * @memberof ProjectDTO
     */
    partner?: Array<ReferencedOrganisationDTO>;
    /**
     * 
     * @type {Array<ProjectToPersonDTO>}
     * @memberof ProjectDTO
     */
    projectPersons?: Array<ProjectToPersonDTO>;
    /**
     * 
     * @type {Array<ExternalIdDTO>}
     * @memberof ProjectDTO
     */
    externalIds?: Array<ExternalIdDTO>;
    /**
     * 
     * @type {Array<ProjectInstitutionalIdDTO>}
     * @memberof ProjectDTO
     */
    projectInstitutionalIds?: Array<ProjectInstitutionalIdDTO>;
    /**
     * 
     * @type {Array<UrlDTO>}
     * @memberof ProjectDTO
     */
    urls?: Array<UrlDTO>;
    /**
     * 
     * @type {Array<ProjectOtherPartnerDTO>}
     * @memberof ProjectDTO
     */
    projectOtherPartners?: Array<ProjectOtherPartnerDTO>;
    /**
     * 
     * @type {Array<ProjectPersonOtherDTO>}
     * @memberof ProjectDTO
     */
    projectPersonOthers?: Array<ProjectPersonOtherDTO>;
    /**
     * 
     * @type {Array<SubjectDTO>}
     * @memberof ProjectDTO
     */
    projectSubjects?: Array<SubjectDTO>;
    /**
     * 
     * @type {Array<ProjectFundingReferenceDTO>}
     * @memberof ProjectDTO
     */
    projectFundingReferences?: Array<ProjectFundingReferenceDTO>;
    /**
     * 
     * @type {AdminDataProjectDTO}
     * @memberof ProjectDTO
     */
    adminDataProject?: AdminDataProjectDTO;
}

/**
 * Check if a given object implements the ProjectDTO interface.
 */
export function instanceOfProjectDTO(value: object): value is ProjectDTO {
    return true;
}

export function ProjectDTOFromJSON(json: any): ProjectDTO {
    return ProjectDTOFromJSONTyped(json, false);
}

export function ProjectDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'canEdit': json['canEdit'] == null ? undefined : json['canEdit'],
                'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
                  'name': json['name'] == null ? undefined : json['name'],
              'otherNames': json['otherNames'] == null ? undefined : ((json['otherNames'] as Array<any>).map(ProjectOtherNameDTOFromJSON)),
                  'note': json['note'] == null ? undefined : json['note'],
                  'oldId': json['oldId'] == null ? undefined : json['oldId'],
                'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
              'parents': json['parents'] == null ? undefined : ((json['parents'] as Array<any>).map(ReferencedProjectDTOFromJSON)),
              'childs': json['childs'] == null ? undefined : ((json['childs'] as Array<any>).map(ReferencedProjectDTOFromJSON)),
              'successor': json['successor'] == null ? undefined : ((json['successor'] as Array<any>).map(ReferencedProjectDTOFromJSON)),
              'predecessors': json['predecessors'] == null ? undefined : ((json['predecessors'] as Array<any>).map(ReferencedProjectDTOFromJSON)),
              'partner': json['partner'] == null ? undefined : ((json['partner'] as Array<any>).map(ReferencedOrganisationDTOFromJSON)),
              'projectPersons': json['projectPersons'] == null ? undefined : ((json['projectPersons'] as Array<any>).map(ProjectToPersonDTOFromJSON)),
              'externalIds': json['externalIds'] == null ? undefined : ((json['externalIds'] as Array<any>).map(ExternalIdDTOFromJSON)),
              'projectInstitutionalIds': json['projectInstitutionalIds'] == null ? undefined : ((json['projectInstitutionalIds'] as Array<any>).map(ProjectInstitutionalIdDTOFromJSON)),
              'urls': json['urls'] == null ? undefined : ((json['urls'] as Array<any>).map(UrlDTOFromJSON)),
              'projectOtherPartners': json['projectOtherPartners'] == null ? undefined : ((json['projectOtherPartners'] as Array<any>).map(ProjectOtherPartnerDTOFromJSON)),
              'projectPersonOthers': json['projectPersonOthers'] == null ? undefined : ((json['projectPersonOthers'] as Array<any>).map(ProjectPersonOtherDTOFromJSON)),
              'projectSubjects': json['projectSubjects'] == null ? undefined : ((json['projectSubjects'] as Array<any>).map(SubjectDTOFromJSON)),
              'projectFundingReferences': json['projectFundingReferences'] == null ? undefined : ((json['projectFundingReferences'] as Array<any>).map(ProjectFundingReferenceDTOFromJSON)),
                  'adminDataProject': json['adminDataProject'] == null ? undefined : AdminDataProjectDTOFromJSON(json['adminDataProject']),
    };
}

export function ProjectDTOToJSON(json: any): ProjectDTO {
    return ProjectDTOToJSONTyped(json, false);
}

export function ProjectDTOToJSONTyped(value?: ProjectDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'canEdit': value['canEdit'],
        'endDate': value['endDate']?.toISOString().substring(0,10),
        'name': value['name'],
        'otherNames': value['otherNames'] == null? value['otherNames']: (value['otherNames'] as Array<any>).map(ProjectOtherNameDTOToJSON),
        'note': value['note'],
        'oldId': value['oldId'],
        'startDate': value['startDate']?.toISOString().substring(0,10),
        'parents': value['parents'] == null? value['parents']: (value['parents'] as Array<any>).map(ReferencedProjectDTOToJSON),
        'childs': value['childs'] == null? value['childs']: (value['childs'] as Array<any>).map(ReferencedProjectDTOToJSON),
        'successor': value['successor'] == null? value['successor']: (value['successor'] as Array<any>).map(ReferencedProjectDTOToJSON),
        'predecessors': value['predecessors'] == null? value['predecessors']: (value['predecessors'] as Array<any>).map(ReferencedProjectDTOToJSON),
        'partner': value['partner'] == null? value['partner']: (value['partner'] as Array<any>).map(ReferencedOrganisationDTOToJSON),
        'projectPersons': value['projectPersons'] == null? value['projectPersons']: (value['projectPersons'] as Array<any>).map(ProjectToPersonDTOToJSON),
        'externalIds': value['externalIds'] == null? value['externalIds']: (value['externalIds'] as Array<any>).map(ExternalIdDTOToJSON),
        'projectInstitutionalIds': value['projectInstitutionalIds'] == null? value['projectInstitutionalIds']: (value['projectInstitutionalIds'] as Array<any>).map(ProjectInstitutionalIdDTOToJSON),
        'urls': value['urls'] == null? value['urls']: (value['urls'] as Array<any>).map(UrlDTOToJSON),
        'projectOtherPartners': value['projectOtherPartners'] == null? value['projectOtherPartners']: (value['projectOtherPartners'] as Array<any>).map(ProjectOtherPartnerDTOToJSON),
        'projectPersonOthers': value['projectPersonOthers'] == null? value['projectPersonOthers']: (value['projectPersonOthers'] as Array<any>).map(ProjectPersonOtherDTOToJSON),
        'projectSubjects': value['projectSubjects'] == null? value['projectSubjects']: (value['projectSubjects'] as Array<any>).map(SubjectDTOToJSON),
        'projectFundingReferences': value['projectFundingReferences'] == null? value['projectFundingReferences']: (value['projectFundingReferences'] as Array<any>).map(ProjectFundingReferenceDTOToJSON),
        'adminDataProject': AdminDataProjectDTOToJSON(value['adminDataProject']),
    };
}


